<div class="modal-header">
  <h5 class="modal-title">
    {{ itemId ? 'რედაქტირება' : 'დამატება' }}
  </h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <app-spinner [loading]="loading" text="იტვირთება..."></app-spinner>

  <div class="mb-3">
    <label class="form-label">სახელი</label>
    <input class="form-control" [(ngModel)]="model.name" />
  </div>

  <div class="mb-3">
    <label class="form-label">თანამდებობა</label>
    <input class="form-control" [(ngModel)]="model.work_position" />
  </div>

  <div class="mb-3">
    <label class="form-label">გამოჩენა</label>
    <select class="form-select" [(ngModel)]="model.visible">
      <option [ngValue]="1">ჩანს</option>
      <option [ngValue]="0">არ ჩანს</option>
    </select>
  </div>

  <!-- ფოტო (image) -->
  <div class="mb-3">
    <label class="form-label">ფოტო</label>

    <div class="d-flex flex-column gap-2">
      <div *ngIf="model.image" class="d-flex align-items-center gap-3">
        <img
          [src]="getImagePreviewUrl()"
          alt="team"
          style="width: 120px; height: 120px; object-fit: cover; border-radius: 8px; border: 1px solid #e5e5e5;"
        />
        <div class="d-flex flex-column gap-2">
          <small class="text-muted">{{ model.image }}</small>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="model.image = ''">ფოტოს წაშლა</button>
        </div>
      </div>

      <!-- upload only after the item exists (so you have an id/page to attach later if needed) -->
      <app-upload
        *ngIf="itemId"
        [uploadPath]="getTeamUploadPath()"
        (uploaded)="onFileUploaded($event)"
      ></app-upload>

      <small *ngIf="!itemId" class="text-muted">
        ფოტო რომ ატვირთო, ჯერ შეინახე ჩანაწერი (დამატება), მერე გამოჩნდება ატვირთვა.
      </small>
    </div>
  </div>

  <!-- კონტენტი / ბიოგრაფია (HTML) -->
  <div class="mb-3">
    <label class="form-label">ბიოგრაფია / კონტენტი</label>

    <editor
      [(ngModel)]="model.content"
      [init]="{
        base_url: '/tinymce',
        license_key: 'gpl',
        suffix: '.min',
        plugins: 'link image fullscreen lists table code preview',
        toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code preview | fullscreen'
      }"
    ></editor>

    <small class="text-muted">
      აქ შეგიძლია ჩასვა ფორმატირებული ტექსტი (HTML), სურათები და ცხრილები.
    </small>
  </div>

  <!-- საკონტაქტო / სოციალური -->
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <label class="form-label">Facebook</label>
      <input class="form-control" [(ngModel)]="model.facebook" placeholder="https://facebook.com/..." />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">LinkedIn</label>
      <input class="form-control" [(ngModel)]="model.linkedin" placeholder="https://linkedin.com/in/..." />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">Gmail</label>
      <input class="form-control" [(ngModel)]="model.gmail" placeholder="name@gmail.com" />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">ტელეფონი</label>
      <input class="form-control" [(ngModel)]="model.phone" placeholder="(0322) 28 54 11" />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">დაბადების თარიღი</label>
      <input class="form-control" [(ngModel)]="model.birthday" placeholder="1987 წლის 01 აგვისტო" />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">კანდიდატი</label>
      <input class="form-control" [(ngModel)]="model.candidat" placeholder="ქართული ოცნება-დემოკრატიული საქართველო" />
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label">არჩევნები</label>
      <input class="form-control" [(ngModel)]="model.archevnebi" />
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-light" (click)="activeModal.dismiss()">დახურვა</button>
  <button class="btn btn-primary" (click)="save()">შენახვა</button>
</div>